// extracted by mini-css-extract-plugin
export var peopleLinks = "PeopleLinks-module--peopleLinks--CH6IC";
export var linkEmail = "PeopleLinks-module--linkEmail--3swOw";
export var linkVcard = "PeopleLinks-module--linkVcard--1hkmx";
export var linkLinkedin = "PeopleLinks-module--linkLinkedin--2mBFp";
export var linkPdf = "PeopleLinks-module--linkPdf--3UT9N";
export var icon = "PeopleLinks-module--icon--2J-d_";